import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { HeroSection } from '@/components/landing/hero-section'
import { TrustStrip } from '@/components/landing/trust-strip'
import { CategoriesSection } from '@/components/landing/categories-section'
import { HowItWorksSection } from '@/components/landing/how-it-works-section'
import { SimulatorSection } from '@/components/landing/simulator-section'
import { ContemplationSection } from '@/components/landing/contemplation-section'
import { ComparisonSection } from '@/components/landing/comparison-section'
import { ConsultingSection } from '@/components/landing/consulting-section'
import { FaqSection } from '@/components/landing/faq-section'
import { LeadFormSection } from '@/components/landing/lead-form-section'
import { useProposalSelection } from '@/hooks/use-proposal-selection'
import { generalFaq } from '@/constants/consorcios'

const Home: FC = (): ReactNode => {
    const { selection, requestProposal, clearSelection } = useProposalSelection()

    return (
        <Layout ctaHref='#contato'>
            <Seo />

            <HeroSection />
            <TrustStrip />
            <CategoriesSection />
            <HowItWorksSection />
            <SimulatorSection onRequestProposal={requestProposal} />
            <ContemplationSection />
            <ComparisonSection />
            <ConsultingSection />
            <FaqSection items={generalFaq} />
            <LeadFormSection selection={selection} onClearSelection={clearSelection} />
        </Layout>
    )
}

export default Home
